import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Title from './Title';
import { Button } from '@material-ui/core';
import { styles as containerStyles } from '../styles/container';
import { anaBlue, highlightColor } from './Ana';
import { COVID_19_NEWS } from '../variables.js';
import { anaBackgroundColor } from './Ana';
import withStyles from '@material-ui/core/styles/withStyles';
import { Paper } from '@material-ui/core';
import { useMediaQuery } from '@material-ui/core';
import PapersIcon from '../../../images/features/ana/papers.png';
import StepImage from '../../../images/features/ana/step_image.png';
import StepImage2 from '../../../images/features/ana/step_image2.png';
import Steps from './Steps';
import Typography from '@material-ui/core/Typography';
import Balloon1 from '../../../images/features/ana/balloon1.png';
import Balloon2 from '../../../images/features/ana/balloon2.png';
import { makeTransformStyles } from '../../core/styles';

const steps = [
  {
    title: 'step 01',
    details: ['おてつたびに', '申し込む'],
    description:
      'こちらのページから行きたいおてつたび先の内容を確認して、申し込んでください。（おてつたびを利用するには本サイトの新規登録が必要）',
    color: '#37AAB4',
    className: 'step1',
  },
  {
    title: 'step 02',
    details: ['おてつたび先と', 'マッチング'],
    description:
      '申し込んだおてつたび先が受け入れ承認を行います。そちらの承認後にマッチングが成立します。',
    color: '#2FA5C7',
    className: 'step2',
  },
  {
    title: 'step 03',
    details: ['ANAトラベラーズで', '航空券と宿泊先を', '予約'],
    description:
      'マッチング後に登録したメールアドレスにメールが届きます。メールに記載されているURLより「ANAトラベラーズダイナミックパッケージ（航空券＋宿泊）」の申し込みを行なってください。（宿泊の申し込みはおてつたび前後どちらかのみでも可能です！）',
    color: '#2E75B1',
    className: 'step3',
  },
  {
    title: '',
    details: ['観光など'],
    color: '#2E54B1',
    className: 'sightseeing',
  },
  {
    title: 'step 04',
    details: ['おてつたび本番'],
    additional: '（おてつたび先で宿泊）',
    description:
      '日程が来たらおてつたび先に向かいます。地域の方と交流を楽しみながら、お手伝いに応じて報酬を受け取ってください。',
    color: '#0B318F',
    className: 'step4',
  },
  {
    title: '',
    details: ['観光など'],
    color: '#2E54B1',
    className: 'sightseeing2',
  },
];

// const ListButton = withStyles((theme) => ({
//   root: {
//     maxWidth: 560,
//     height: 80,
//     margin: '12px 0',
//     fontWeight: 'bold',
//     fontSize: 18,
//   },
// }))(Button);

const NewsButton = withStyles((theme) => ({
  root: {
    maxWidth: 560,
    height: 60,
    margin: '12px 0',
    fontWeight: 'bold',

    color: 'white',
    backgroundColor: anaBlue,
    '&:hover': {
      color: 'white',
      backgroundColor: '#2E75B1',
    },
  },
  label: {
    '&:hover': {
      color: 'white',
    },
  },
  startIcon: {
    '& img': {
      width: 50,
      height: 36.38,
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: anaBackgroundColor,
  },
  wrapper: {
    width: '100%',
    maxWidth: theme.breakpoints.values.lg,
    margin: 'auto',
    ...containerStyles(theme),
  },
  containerSteps: {
    width: '100%',
    overflow: 'hidden',
    margin: '20px 0',
    paddingRight: 20,
    textAlign: 'center',
  },
  containerStep: {
    verticalAlign: 'middle',
    width: 140,
    display: 'table-cell',
    position: 'relative',
    backgroundColor: '#2E54B1',
    color: 'white',
    '&::before, &::after': {
      content: "''",
      position: 'absolute',
      width: 0,
      height: 0,
      margin: 'auto',
    },
    '&::before': {
      top: -52,
      right: '-1.4em',
      borderStyle: 'solid',
      borderColor: `transparent transparent transparent ${anaBackgroundColor}`,
      borderWidth: '150px 0 150px 1.5em',
      zIndex: 10,
    },
    '&::after': {
      top: -52,
      right: '-1.0em',
      borderStyle: 'solid',
      borderColor: 'transparent transparent transparent #2E54B1',
      borderWidth: '150px 0 150px 1.5em',
      zIndex: 10,
    },
  },
  step1: {
    backgroundColor: '#37AAB4',
    width: 200,
    '&::after': {
      borderColor: `transparent transparent transparent #37AAB4`,
    },
  },
  step2: {
    backgroundColor: '#2FA5C7',
    width: 200,
    '&::after': {
      borderColor: `transparent transparent transparent #2FA5C7`,
    },
  },
  step3: {
    backgroundColor: '#2E75B1',
    width: 200,
    '&::after': {
      borderColor: `transparent transparent transparent #2E75B1`,
    },
  },
  step4: {
    backgroundColor: '#0B318F',
    width: 200,
    '&::after': {
      borderColor: `transparent transparent transparent #0B318F`,
    },
  },
  sightseeing: {
    width: 150,
    '& p': {
      top: '50%',
    },
  },
  stepWrapper: {
    marginTop: 25,
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(4),
    },
  },
  containerBalloons: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  balloon: {
    position: 'absolute',
    zIndex: 20,
    top: -30,
  },
  balloon1: {
    left: '56%',
  },
  balloon2: {
    left: '87.5%',
  },
  stepImage: {
    width: 100,
    position: 'absolute',
    bottom: 0,
    left: 10,
  },
  stepTitle: {
    display: 'inline-block',
    fontSize: theme.typography.pxToRem(16),
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    background: `linear-gradient(transparent 80%, ${highlightColor} 80%)`,
    marginBottom: theme.spacing(1),
  },
  stepDetails: {
    width: '100%',
    textAlign: 'center',
    '& > *': {
      display: 'block',
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(14),
      [theme.breakpoints.up('lg')]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
  },
  stepAdditional: {
    fontSize: 12,
    display: 'block',
  },
  stepBalloon: {
    width: '100%',
    maxWidth: 110,
    height: 'auto',
    top: -150,
    left: 0,
    right: 0,
  },
  containerCardWrapper: {
    margin: theme.spacing(2.5, 'auto', 1.5),
  },
  card: {
    borderWidth: 3,
    borderStyle: 'solid',
    backgroundColor: 'white',
    // margin: 10,
    width: '100%',

    padding: '1em 1.5em',
    minHeight: 0,
    [theme.breakpoints.up('md')]: {
      padding: '2em 2.5em',
      maxWidth: 1000,
      minHeight: 170,
      '&.step3, &.step4': {
        minHeight: 194,
      },
    },
  },
  containerCardTitle: {
    display: 'flex',
    alignItems: 'baseline',
  },
  cardStepTitle: {
    fontSize: 14,
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    height: 'fit-content',
    position: 'relative',
    bottom: 2,
  },
  highlight: {
    background: `linear-gradient(transparent 80%, ${highlightColor} 80%)`,
  },
  cardStepDetails: {
    fontSize: 18,
    fontWeight: 'bold',
    marginLeft: 12,
  },
  cardStepDescription: {
    fontSize: 14,
    marginTop: '1em',
  },
  containerPointTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: '1em',
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  point: {
    fontWeight: 'bold',
    background: `linear-gradient(transparent 70%, ${highlightColor} 70%)`,
  },
  pointTitle: {
    margin: theme.spacing(1.5, 0, 0),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 'bold',
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(20),
    },
    '& > *': {
      display: 'inline',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
  },
  containerPointWrapper: {
    margin: '50px 0',
  },
  containerPoint: {
    position: 'relative',
    width: '100%',
    margin: theme.spacing(3, 0),
    '&::before, &::after': {
      content: "''",
      width: 15,
      height: '100%',
      position: 'absolute',
      borderTop: 'solid 3px #2E54B1',
      borderBottom: 'solid 3px #2E54B1',
      top: 0,
    },
    '&::before': {
      borderLeft: 'solid 3px #2E54B1',
      left: 0,
    },
    '&::after': {
      borderRight: 'solid 3px #2E54B1',
      right: 0,
    },
    '& > *': {
      padding: theme.spacing(1, 2),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(1, 3),
      },
    },
  },
  pointBalloon: {
    width: '100%',
    height: 'auto',
    ...makeTransformStyles('scale(1.5)'),
    [theme.breakpoints.up('sm')]: {
      ...makeTransformStyles('scale(1.3)'),
    },
  },
  pointDescription: {
    display: 'flex',
    '& > *': {
      margin: 'auto',
    },
  },
  containerButtons: {
    textAlign: 'center',
  },
  buttonDescription: {
    fontWeight: 'bold',
  },
  containerButton: {
    margin: '12px 0',
  },
}));

const HowToApply = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Title texts={['コラボおてつたびへの', '参加方法']} />
        <div className={classes.stepWrapper}>
          {matches ? (
            <div className={classes.containerBalloons}>
              <div className={clsx(classes.balloon, classes.balloon1)}>
                <img src={Balloon1} className={classes.stepBalloon} />
              </div>
              <div className={clsx(classes.balloon, classes.balloon2)}>
                <img src={Balloon1} className={classes.stepBalloon} />
              </div>
              <div
                className={classes.containerSteps}
                style={{ display: matches ? 'table' : 'none' }}
              >
                {steps.map((step, index) => (
                  <div
                    key={index}
                    className={clsx(
                      classes.containerStep,
                      classes[step.className],
                    )}
                    style={{
                      height: matches ? 200 : 0,
                      ...(matches &&
                        !!step.title && {
                          verticalAlign: 'sub',
                          paddingTop: 50,
                        }),
                    }}
                  >
                    {step.title && (
                      <div>
                        <span
                          className={classes.stepTitle}
                          style={{ marginLeft: index > 0 ? 15 : 8 }}
                        >
                          {step.title}
                        </span>
                      </div>
                    )}
                    <p
                      className={classes.stepDetails}
                      style={{
                        padding: index > 0 ? '0 0.5em 0 2.5rem' : '0 1em 0 2em',
                      }}
                    >
                      {step.details.map((detail, index) => (
                        <span key={index}>{detail}</span>
                      ))}
                      <span className={classes.stepAdditional}>
                        {step.additional}
                      </span>
                    </p>
                    {['sightseeing', 'sightseeing2'].includes(
                      step.className,
                    ) && (
                      <img
                        src={
                          step.className === 'sightseeing'
                            ? StepImage
                            : StepImage2
                        }
                        alt="step_image"
                        className={classes.stepImage}
                      />
                    )}
                    {step.className === 'sightseeing2' && (
                      <img
                        src={StepImage2}
                        alt="step_image"
                        className={classes.stepImage}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Steps steps={steps} />
          )}
        </div>

        <div className={classes.containerCardWrapper}>
          <Grid container spacing={2}>
            {steps
              .filter((step) => step.title)
              .map((step, index) => (
                <Grid
                  key={index}
                  item
                  sm={12}
                  md={6}
                  container
                  justify="center"
                >
                  <Paper
                    square
                    elevation={0}
                    className={clsx(classes.card, step.className)}
                    style={{ borderColor: step.color }}
                  >
                    <p className={classes.containerCardTitle}>
                      <span
                        className={clsx(
                          classes.cardStepTitle,
                          classes.highlight,
                        )}
                        style={{ color: step.color }}
                      >
                        {step.title}
                      </span>
                      <span className={classes.cardStepDetails}>
                        {step.details.join('')}
                      </span>
                    </p>
                    <p className={classes.cardStepDescription}>
                      {step.description}
                    </p>
                  </Paper>
                </Grid>
              ))}
          </Grid>
        </div>

        <div>
          <Grid container className={classes.containerPoint} justify="center">
            <Grid item xs={12} md={6} lg={5} container>
              <Grid item xs={3}>
                <img src={Balloon2} className={classes.pointBalloon} />
              </Grid>
              <Grid item xs={9} className={classes.containerPointTitle}>
                <div>
                  <div>
                    <span className={clsx(classes.highlight, classes.point)}>
                      コラボおてつたびのポイント！
                    </span>
                  </div>
                  <p className={classes.pointTitle}>
                    <span>おてつたび前後に宿泊して</span>
                    <span>もっと地域の魅力を知ろう！</span>
                  </p>
                </div>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={7}
              className={classes.pointDescription}
            >
              <Typography>
                通常のおてつたびプランでは前後の宿泊は含まれておりませんが、今回のコラボではおてつたび前後に宿泊いただくことで、よりゆったりと訪れた地域の魅力を感じることができます！観光などでその地域の良さや文化などをを思う存分楽しんでください！
              </Typography>
            </Grid>
          </Grid>
        </div>

        <Grid
          container
          spading={3}
          className={classes.containerButtons}
          justify="center"
        >
          {/*<Grid item xs={12}>*/}
          {/*  <span className={classes.buttonDescription}>\\ おてつたびで知らない地域の魅力を再発見 //</span>*/}
          {/*</Grid>*/}
          {/*<Grid item xs={12}>*/}
          {/*  <ListButton fullWidth variant="contained" color="primary">*/}
          {/*    コラボおてつたび一覧はこちら*/}
          {/*  </ListButton>*/}
          {/*</Grid>*/}
          <Grid item xs={12}>
            <NewsButton
              fullWidth
              variant="contained"
              href={COVID_19_NEWS}
              startIcon={<img src={PapersIcon} alt="papers_icon" />}
            >
              <div>
                <span className="d-inline-block">
                  新型コロナウイルス感染予防
                </span>
                <span className="d-inline-block">のための</span>
                <span className="d-inline-block">ご協力のお願い</span>
              </div>
            </NewsButton>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default HowToApply;
